import { boolean, object, array, string, mixed } from 'yup';

const makeSchema = data => {
  if (data.length === 0) return;
  let schema = {};

  for (let prop in data) {
    schema[prop] = string().required('This field can not be empty!');
  }

  return object().shape(schema);
};

export default makeSchema;
